







































import Vue from "vue";
import { Dialog } from "@/lib/utils";
import RubyDialog, { RubyDialogProps } from "@/components/ui/RubyDialog.vue";
import EmphasisMarkDialog, { EmphasisMarkDialogProps } from "@/components/ui/EmphasisMarkDialog.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  methods: {
    brackets() {
      document.getElementById("textarea")!.focus();
      const selectedText = window.getSelection()!.toString();
      document.execCommand("insertText", false, `「${selectedText}」`);
    },
    ellipsis() {
      document.getElementById("textarea")!.focus();
      document.execCommand("insertText", false, "……");
    },
    space() {
      document.getElementById("textarea")!.focus();
      document.execCommand("insertText", false, "　");
    },
    dash() {
      document.getElementById("textarea")!.focus();
      document.execCommand("insertText", false, "――");
    },
    async ruby() {
      document.getElementById("textarea")!.focus();
      const selectedText = window.getSelection()!.toString();

      const rubyDialog = new Dialog(RubyDialog);
      const data: RubyDialogProps = {
        selectedText,
        negative: "キャンセル",
        positive: "入力する",
      };
      const result = await rubyDialog.show(data);

      document.getElementById("textarea")!.focus();

      if (!result) return;
      document.execCommand("insertText", false, result);
    },
    async emphasisMark() {
      document.getElementById("textarea")!.focus();
      const selectedText = window.getSelection()!.toString();

      const emphasisMarkDialog = new Dialog(EmphasisMarkDialog);
      const data: EmphasisMarkDialogProps = {
        selectedText,
        negative: "キャンセル",
        positive: "入力する",
      };
      const result = await emphasisMarkDialog.show(data);

      document.getElementById("textarea")!.focus();

      if (!result) return;
      document.execCommand("insertText", false, result);
    },
    undo() {
      document.execCommand("undo", false, undefined);
    },
    redo() {
      document.execCommand("redo", false, undefined);
    },
  },
});

interface Props {}

interface Data {}

interface Computed {}

interface Methods {
  brackets(): void;
  ellipsis(): void;
  space(): void;
  dash(): void;
  ruby(): void;
  emphasisMark(): void;
  undo(): void;
  redo(): void;
}
